module.exports = __webpack_public_path__ + "static/media/16UNODC2.5813a415.jpg";